import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';

const TermsOfUsePage: React.FC = () => {
  const { currentLang } = useLanguage();

  const hebrewContent = (
    <>
      <Typography variant="h4" component="h1" gutterBottom>
        תקנון אתר
      </Typography>
      
      <Typography variant="h6" gutterBottom>
        עודכן לאחרונה: {new Date().toLocaleDateString('he-IL')}
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          מבוא
        </Typography>
        <Typography paragraph>
          • אתר Inbal Art Makers ("האתר") המופעל על ידי ענבל לוין ("הבעלים") משמש כפלטפורמה להדרכות קריקאט וצורפות, פרסום סדנאות, ומכירת מוצרי אומנות ותכשיטי עבודת יד ("המוצר").
          <br />
          • האמור בתקנון זה בלשון זכר הוא לשם הנוחות בלבד והתקנון מתייחס לבני שני המינים באופן שווה.
          <br />
          • הרכישה באמצעות האתר כפופה לתנאים המפורטים בתקנון זה.
          <br />
          • עצם רכישת המוצר באתר תהווה הצהרה מצד הלקוח כי קרא את הוראות תקנון זה, הבין אותן והסכים להן. התקנון מהווה חוזה מחייב בינך לבין הבעלים.
        </Typography>

        <Typography variant="h6" gutterBottom>
          הגבלת גיל
        </Typography>
        <Typography paragraph>
          • תנאי לרכישה באתר כי הרוכש הינו בן 18 שנים ומעלה.
          <br />
          • החברה שומרת לעצמה את הזכות לבקש הוכחת גיל בכל עת.
          <br />
          • רכישה על ידי קטין מתחת לגיל 18 תהיה בטלה ומבוטלת.
        </Typography>

        <Typography variant="h6" gutterBottom>
          הרכישה
        </Typography>
        <Typography paragraph>
          • האתר מאפשר ללקוחות קנייה נוחה, קלה ובטוחה של המוצרים באמצעות האינטרנט.
          <br />
          • ניתן לרכוש את המוצרים באתר בכל עת עד לגמר המלאי.
          <br />
          • הרכישה באתר הינה באמצעות כרטיס אשראי בלבד והעסקה תתבצע לאחר אישורה ע"י חברת האשראי.
          <br />
          • הסליקה מבוצעת על ידי Morning Digital Payments.
          <br />
          • מחירי המוצרים באתר כוללים את המע"מ.
          <br />
          • החברה שומרת לעצמה את הזכות להפסיק את שיווק ומכירת המוצרים בכל עת וכן לשלול זכות רכישה באתר מכירות על פי שיקול דעתה.
          <br />
          • האתר מציע שני סוגי מוצרים:
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;א. מוצרים דיגיטליים - תוכן דיגיטלי לצפייה באתר (כגון תמונות, גלריות, וכו').
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;ב. מוצרים פיזיים - יצירות אמנות מקוריות, תכשיטים בעבודת יד, פריטי עיצוב, ומוצרים ייחודיים אחרים.
          <br />
          • רכישה של מוצרים דיגיטליים הינה סופית ואינה ניתנת לביטול או להחזר, זאת בשל אופיים הדיגיטלי של המוצרים.
          <br />
          • רכישה של מוצרים פיזיים כפופה למדיניות ההחזרות והביטולים המפורטת בסעיף "החזרות וביטולים".
        </Typography>

        <Typography variant="h6" gutterBottom>
          החזרות וביטולים
        </Typography>
        <Typography paragraph>
          • ביטול עסקה והחזרת מוצר יתאפשרו עפ״י תקנון זה ובהתאם לחוק הגנת הצרכן,השתמ״א-1981.
          <br />
          • לא ניתן לבטל ולקבל החזר כספי על הקורס הדיגיטלי ע"פ סעיפים 14ג- 14ה לחוק הגנת הצרכן.
          <br />
          • ניתן לבטל את העסקה באמצעות פניה טלפונית או בדואר אלקטרוני לשירות הלקוחות של החברה. ביטול העסקה יהיה בתוקף אך ורק לאחר קבלת אישור מהחברה בדואר אלקטרוני המאשר את הבקשה לביטול העסקה. במקרה שהביטול אושר – יש להשיב את המוצר לחברה כאשר כל העלויות הכרוכות בהחזרת המוצר תחולנה על הלקוח. החזרת המוצר תיעשה כשהוא באריזתו המקורית בצירוף החשבונית המקורית ושעדיין לא חלפו 30 יום מתאריך רכישת המוצר.
          <br />
          • במקרה של ביטול העסקה, תחזיר החברה ללקוח את סכום הרכישה.
          <br />
          • אם ביטול העסקה יתבצע לאחר שהלקוח כבר קיבל את המוצר לרשותו, הלקוח יישא בעלות משלוח המוצר חזרה לחברה, זאת בנוסף לדמי הביטול.
          <br />
          • מדיניות ביטול העסקה המפורטת לעיל תחול רק ביחס למוצרים שנרכשו באתר. החברה לא תטפל בהחזרת מוצרים שנרכשו באמצעות מקור אחר.
        </Typography>

        <Typography variant="h6" gutterBottom>
          אספקה והובלת המוצר
        </Typography>
        <Typography paragraph>
          • מוצרים שאינם מותאמים אישית (שאינם מסומנים כ"מותאם אישית") יסופקו באמצעות דואר ישראל.
          <br />
          • זמן הכנת המוצר ועד מסירתו לדואר ישראל הוא עד 7 ימי עסקים.
          <br />
          • לאחר מסירת המוצר לדואר ישראל, יימסר ללקוח מספר מעקב למשלוח.
          <br />
          • החברה אינה אחראית לעיכובים ו/או איחורים בדואר ישראל.
          <br />
          • מוצרים המסומנים כמותאמים אישית ניתנים לאיסוף עצמי בלבד מכתובת החברה בהרצליה, רחוב יגאל אלון.
          <br />
          • הלקוח רשאי לפנות לאחר הרכישה, באמצעות דף יצירת הקשר, בבקשה לאיסוף עצמי של המוצר; המחיר שנקבע בעת הרכישה יישאר ללא שינוי.
          <br />
          • החברה לא תהא אחראית לכל איחור ו/או עיכוב באיסוף המוצר ו/או אי-איסוף, שנגרמו כתוצאה מכוח עליון ו/או מאירועים שאינם בשליטתה.
        </Typography>

        <Typography variant="h6" gutterBottom>
          שירות לקוחות
        </Typography>
        <Typography paragraph>
          • בכל שאלה או בירור לגבי המוצר, ניתן לפנות אל נציגי השירות של החברה בטלפון 054-7798844
        </Typography>

        <Typography variant="h6" gutterBottom>
          אחריות ושירות
        </Typography>
        <Typography paragraph>
          • בעת איסוף המוצרים, הקונה מחויב לבדוק את מצב המוצר ולוודא שהוא שלם ומתאים לציפיותיו. לאחר איסוף המוצר לא תתאפשר החלפה או החזרה מכל סיבה שהיא.
          <br />
          • החברה מעניקה אחריות לתיקונים לתכשיטים בלבד, לתקופה של 12 חודשים מיום הרכישה.
          <br />
          • האחריות לתכשיטים תינתן רק ללקוח שיציג חשבונית מקורית ויוכיח כי הרכישה בוצעה דרך האתר.
          <br />
          • החברה רשאית לדרוש מהלקוח להציג מסמכים המעידים על היותו הרוכש המקורי של התכשיט.
          <br />
          • במקרה של פגם בתכשיט, החברה תספק שירות תיקון בלבד, ללא אפשרות להחלפת התכשיט.
          <br />
          • האחריות לא תחול במקרים של נזק שנגרם כתוצאה משימוש לא נכון בתכשיט או טיפול לא הולם בו.
        </Typography>

        <Typography variant="h6" gutterBottom>
          אבטחת מידע ופרטיות
        </Typography>
        <Typography paragraph>
          • החברה רשאית להשתמש במידע המופיע בטופס על מנת להביא לך את המידע והשירותים המבוקשים. מידע אישי זה לא ייחשף ולא ייעשה בו שימוש נוסף למטרות שיווקיות ללא רשות.
          <br />
          • החברה נוקטת באמצעי זהירות מקובלים על מנת לשמור, ככל האפשר, על סודיות המידע. במקרים שאינם בשליטת החברה ו/או הנובעים מכוח עליון, לא תהא החברה אחראית לכל נזק מכל סוג שהוא, ישר או עקיף, שייגרם ללקוח, אם מידע זה יאבד ו/או יעשה בו שימוש לא מורשה.
          <br />
          • החברה מתחייבת שלא לעשות שימוש במידע המסופק לה ע"י הקונים אלא על מנת לאפשר את הרכישה באתר מכירות ובהתאם לכל דין.
        </Typography>

        <Typography variant="h6" gutterBottom>
          פרטיות
        </Typography>
        <Typography paragraph>
          • החברה משתמשת במידע האישי שמסרו המשתמשים לצורך מתן שירותים באתר, ביצוע רכישות, וניהול חשבון המשתמש.
          <br />
          • המידע נשמר במערכות מאובטחות של החברה, עם גישה מוגבלת רק לעובדים הזקוקים למידע לצורך ביצוע תפקידם.
          <br />
          • החברה משתמשת בטכנולוגיות הצפנה מתקדמות לשמירה על אבטחת המידע, ומעדכנת באופן שוטף את אמצעי האבטחה בהתאם לסטנדרטים המקובלים בתעשייה.
          <br />
          • המידע נשמר לתקופה הנדרשת על פי חוק, או עד לבקשת המשתמש למחיקת המידע, לפי המוקדם מביניהם.
          <br />
          • החברה לא תעביר את המידע האישי לצד שלישי, למעט במקרים בהם הדבר נדרש על פי חוק או לצורך מתן השירות.
        </Typography>

        <Typography variant="h6" gutterBottom>
          קניין רוחני
        </Typography>
        <Typography paragraph>
          • כל זכויות הקניין הרוחני באתר זה הינן רכושה הבלעדי של החברה.
          <br />
          • אין להעתיק, לשכפל, להפיץ, לפרסם או להשתמש בכל דרך אחרת במידע כלשהו מן האתר, אלא אם ניתנה הסכמה לכך מראש ובכתב מטעם החברה.
        </Typography>

        <Typography variant="h6" gutterBottom>
          דין וסמכות שיפוט
        </Typography>
        <Typography paragraph>
          • פרשנותו ואכיפתו של תקנון זה ו/או כל פעולה או סכסוך הנובע ממנו יעשו בהתאם לדין הישראלי בלבד, ולבית המשפט השלום בהרצליה תהא מסורה סמכות השיפוט הבלעדית.
        </Typography>
      </Box>
    </>
  );

  const englishContent = (
    <>
      <Typography variant="h4" component="h1" gutterBottom>
        Terms of Use
      </Typography>
      
      <Typography variant="h6" gutterBottom>
        Last updated: {new Date().toLocaleDateString('en-US')}
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Introduction
        </Typography>
        <Typography paragraph>
          • The Inbal Art Makers website ("the Site") operated by Inbal Levin ("the Owner") serves as a platform for crochet and jewelry-making tutorials, workshop publications, and the sale of art products and handmade jewelry ("the Product").
          <br />
          • The use of masculine language in these terms is for convenience only and the terms apply equally to both genders.
          <br />
          • Purchases through the Site are subject to the conditions specified in these terms.
          <br />
          • The purchase of a product on the Site constitutes a declaration by the customer that they have read, understood, and agreed to these terms. These terms constitute a binding contract between you and the Owner.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Age Restriction
        </Typography>
        <Typography paragraph>
          • A condition for purchasing on the site is that the buyer must be 18 years of age or older.
          <br />
          • The company reserves the right to request proof of age at any time.
          <br />
          • Any purchase made by a minor under the age of 18 will be null and void.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Purchase
        </Typography>
        <Typography paragraph>
          • The Site enables customers to make convenient, easy, and secure purchases of products through the internet.
          <br />
          • Products can be purchased on the Site at any time until stock is depleted.
          <br />
          • Purchases on the Site are made by credit card only, and the transaction will be processed after approval by the credit card company.
          <br />
          • Payment processing is handled by Morning Digital Payments.
          <br />
          • Product prices on the Site include VAT.
          <br />
          • The company reserves the right to discontinue marketing and selling products at any time and to deny purchasing rights on the sales site at its discretion.
          <br />
          • The Site offers two types of products:
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;a. Digital products - digital content for viewing on the site (such as images, galleries, etc.).
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;b. Physical products - original artwork, handmade jewelry, design items, and other unique products.
          <br />
          • Digital product purchases are final and cannot be canceled or refunded due to their digital nature.
          <br />
          • Physical product purchases are subject to the return and cancellation policy detailed in the "Returns and Cancellations" section.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Returns and Cancellations
        </Typography>
        <Typography paragraph>
          • Transaction cancellation and product returns are possible according to these terms and in accordance with the Consumer Protection Law, 1981.
          <br />
          • Digital courses cannot be canceled or refunded according to sections 14ג-14ה of the Consumer Protection Law.
          <br />
          • Transactions can be canceled by contacting the company's customer service by phone or email. The cancellation will only be valid after receiving email confirmation from the company approving the cancellation request. If the cancellation is approved, the product must be returned to the company with all return costs borne by the customer. The product must be returned in its original packaging with the original invoice and within 30 days of purchase.
          <br />
          • In case of transaction cancellation, the company will refund the purchase amount to the customer.
          <br />
          • If the cancellation occurs after the customer has received the product, the customer will bear the cost of shipping the product back to the company, in addition to cancellation fees.
          <br />
          • The cancellation policy detailed above applies only to products purchased on the Site. The company will not handle returns of products purchased through other sources.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Supply and Delivery
        </Typography>
        <Typography paragraph>
          • Products that are not customizable (not marked as "customizable") will be delivered via Israel Post.
          <br />
          • The time to prepare the item until it is handed over to Israel Post is up to 7 business days.
          <br />
          • After the product is handed over to Israel Post, the customer will receive a tracking number for the delivery.
          <br />
          • The company is not responsible for delays in Israel Post.
          <br />
          • Customizable products are available for self-pickup only from the company's address in Herzliya, Yigal Alon Street.
          <br />
          • After purchase, the customer may request self-pickup of the product via the contact page; the price determined at the time of purchase will remain unchanged.
          <br />
          • The company will not be responsible for any delay and/or postponement in product pickup and/or non-pickup caused by force majeure and/or events beyond its control.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Customer Service
        </Typography>
        <Typography paragraph>
          • For any questions or inquiries regarding the product, you can contact the company's service representatives at 054-7798844
        </Typography>

        <Typography variant="h6" gutterBottom>
          Warranty and Service
        </Typography>
        <Typography paragraph>
          • When picking up products, the buyer must check the product's condition and ensure it is intact and meets their expectations. After pickup, no exchanges or returns will be possible for any reason.
          <br />
          • The company provides warranty for jewelry repairs only, for a period of 12 months from the date of purchase.
          <br />
          • The warranty for jewelry will only be given to customers who present an original invoice and prove that the purchase was made through the Site.
          <br />
          • The company may require the customer to present documents proving they are the original purchaser of the jewelry.
          <br />
          • In case of a defect in the jewelry, the company will provide repair service only, without the option of replacement.
          <br />
          • The warranty will not apply in cases of damage caused by improper use of the jewelry or improper handling.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Information Security and Privacy
        </Typography>
        <Typography paragraph>
          • The company may use the information provided in the form to bring you the requested information and services. This personal information will not be disclosed or used for additional marketing purposes without permission.
          <br />
          • The company takes reasonable precautions to maintain, as much as possible, the confidentiality of the information. In cases beyond the company's control and/or resulting from force majeure, the company will not be responsible for any damage, direct or indirect, caused to the customer if this information is lost and/or used without authorization.
          <br />
          • The company commits not to use the information provided by buyers except to enable purchases on the sales site and in accordance with all applicable laws.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Privacy
        </Typography>
        <Typography paragraph>
          • The company uses the personal information provided by users for the purpose of providing services on the site, processing purchases, and managing user accounts.
          <br />
          • Information is stored in the company's secure systems, with access limited only to employees who need the information to perform their duties.
          <br />
          • The company uses advanced encryption technologies to maintain information security and regularly updates security measures in accordance with industry standards.
          <br />
          • Information is retained for the period required by law, or until the user requests deletion of the information, whichever comes first.
          <br />
          • The company will not transfer personal information to third parties, except in cases where required by law or necessary for providing the service.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Intellectual Property
        </Typography>
        <Typography paragraph>
          • All intellectual property rights on this site are the exclusive property of the company.
          <br />
          • No information from the site may be copied, reproduced, distributed, published, or used in any other way without prior written consent from the company.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Law and Jurisdiction
        </Typography>
        <Typography paragraph>
          • The interpretation and enforcement of these terms and/or any action or dispute arising from them will be in accordance with Israeli law only, and the Magistrate's Court in Herzliya will have exclusive jurisdiction.
        </Typography>
      </Box>
    </>
  );

  return (
    <Container maxWidth="md" sx={{ py: 4, direction: currentLang === 'he' ? 'rtl' : 'ltr' }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        {currentLang === 'he' ? hebrewContent : englishContent}
        <Typography variant="body2" sx={{ mt: 4, fontStyle: 'italic' }}>
          {currentLang === 'he' 
            ? 'חלקים רבים מתקנון זה הועתקו באישור מאתר החברת בניית חנות ויטואלית iWebsite'
            : 'Many parts of these terms were copied with permission from the iWebsite virtual store building company website'}
        </Typography>
      </Paper>
    </Container>
  );
};

export default TermsOfUsePage; 